import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { MakingDataService } from './md/service/making-data.service';
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  login_with_password = environment.loginWithPassword || false;

  apiHost = environment.apiHost || "https://localhost"
  apiPort = environment.apiPort || "3306"
  version = "22-05-2021";
  httpUrl: any;
  profile_data = '';
  uiHost = environment.apiHost || "https://localhost"
  apiProtocol: any
  constructor(private http: HttpClient, private mds: MakingDataService) {
    this.uiHost = window.location.hostname;
    ////////////////////////////
    // decide protocol based on window location
    if (this.uiHost === "localhost") {
      this.apiProtocol = "http";

    }
    else {

      this.apiProtocol = "https";
    }



    if (this.uiHost.startsWith("dev.acms.upda.co.in")) {
      this.uiHost = 'dev.acms.upda.co.in';
      this.apiPort = 'api';
      this.login_with_password = false;
    }
    else if (this.uiHost.startsWith("acms.upda.co.in")) {
      this.uiHost = 'acms.upda.co.in';
      this.apiPort = 'api';
      this.login_with_password = false;

    }
    // else if (this.uiHost.startsWith("newerp.upneda.co")) {
    //   this.uiHost = 'newerp.upneda.co';
    //   this.apiPort = '3046';

    // }
    else {
      this.uiHost = 'localhost';
    }
    this.httpUrl = this.apiProtocol + '://' + this.uiHost + (this.uiHost.startsWith("dev.acms.upda.co.in") ? "/" : ":") + this.apiPort
    console.log("API @ " + this.httpUrl + " is being used.");
  }

  allLanguage: any = []
  allLableShowObj: any = {};
  allLabel: any = [];
  language_cd: any;
  allLableShowObjProp: any = {};
  allLabelProp: any = [];
  allLableShowObjHR: any = {};
  allLabelHR: any = [];
  allLableShowObjSA: any = {};
  allLabelSA: any = [];
  allSystemModuleObj: any = {};
  changeLanguage() {
    if (this.language_cd == null || this.language_cd == undefined) {
      this.language_cd = 'ENG'
    }
  }

  async getSystemModule() {
    let obj: any = new Object();
    obj['b_acct_id'] = 0;
    var resp = await this.getModules(JSON.stringify(obj));
    if (resp['error'] == false) {
      obj = new Object();
      for (let i = 0; i < resp.data.length; i++) {
        obj[resp.data[i]['module_cd']] = resp.data[i]['module_name']
      }
      this.allSystemModuleObj = obj;

    } else {

    }
  }


  async getAssignModules(b_acct_id: any, role_cd: any) {
    let obj: any = new Object();
    obj['b_acct_id'] = b_acct_id;
    obj['role_cd'] = role_cd;
    var resp = await this.getAllAssignModules(JSON.stringify(obj));
    if (resp['error'] == false) {
      //  obj = new Object();
      // for (let i = 0; i < resp.data.length; i++) {
      //   obj[resp.data[i]['module_cd']] = resp.data[i]['module_name']
      // }
      // this.allSystemModuleObj = obj;
      // console.log( resp.data)
      return resp.data
    } else {
      return []
    }
  }


  async signUp(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/signup', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }



  async login(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/login', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getAllLanguages(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/systemdata/languages/getAllLanguages' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async getAllAssignModules(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/resource/getAssignModules' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }


  async getModules(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/resource/getmodules' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getserver(obj: any) {
    try {
      const res = await this.http.get<any>(this.httpUrl + '/').toPromise().then(res => {
        return res;
      })
      return res;
    } catch (error) {
      return { 'error': true };
    }

  }

  async getcomponentLabelvalueswithLanguage(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/systemdata/languages/getcomponentLabelvalueswithLanguage' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }

  // async getcomponentLabelvalueswithLanguage1(obj) {
  //   const res = await this.http.get<any>(this.httpUrl + '/systemdata/languages/getcomponentLabelvalueswithLanguage1' + obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return res;
  // }

  //   async sendMsg(mobile) {
  //     var str = "https://2factor.in/API/V1/" + this.api_key + "/SMS/" + mobile + "/AUTOGEN"
  //     const resp = await this.http.get<any>(str).toPromise().then(res => {
  //       return res;
  //     });
  //     return resp;

  //   }

  async sendMsg(mobile: any) {
    let obj: any = new Object();
    obj['mobile'] = mobile;
    obj['api_key'] = this.api_key;
    const resp = await this.http.get<any>(this.httpUrl + '/systemdata/authentication/sendOTPMsg' + JSON.stringify(obj)).toPromise().then(res => {
      return res;
    });
    return resp;

  }

  api_key = '4f581079-6160-11ec-b710-0200cd936042';
  // async verifyMsg(otp_entered_by_user:any, session_id:any) {
  //   var str = "https://2factor.in/API/V1/" + this.api_key + "/SMS/VERIFY/" + session_id + "/" + otp_entered_by_user
  //   const resp = await this.http.get<any>(str).toPromise().then(res => {
  //     return true
  //   }).catch(err => {
  //     return false
  //   });
  //   return resp;
  // }
  async verifyMsg(otp_entered_by_user: any, session_id: any) {
    let obj: any = new Object();
    obj['otp_no'] = otp_entered_by_user;
    obj['session_id'] = session_id;
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/verifyOTP', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getaccountmodule(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/systemdata/legalentity/getaccountmodule', { headers: new HttpHeaders().append('data', await this.mds.dataE(obj)) }).toPromise().then(async res => {
      return await this.mds.dataD(res);
    });
    return resp;
  }

  async getCurrentrole(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/role/getcurrentroles' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getCurrentroleForAccount(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/role/getcurrentroles' + obj).toPromise().then(res => {
      return res
    });
    return resp;
  }

  async getCurrentUserFromAdmin(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/user/getcurrentuser' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getCurrentUserFromMD(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/user/getcurrentuser' + JSON.stringify({}), { headers: new HttpHeaders().append('data', await this.mds.dataE(obj)) }).toPromise().then(async res => {
      return await this.mds.dataD(res);
    });
    return resp;
  }

  async loginToAll(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/loginToAll', this.mds.dataE(obj)).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    return resp;
  }

  async verifyLoginToAll(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/verifyLoginToAll', this.mds.dataE(obj)).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    return resp;
  }

  async updateSession(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/updateSession', this.mds.dataE(obj)).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    return resp;
  }

  async getErpUser(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/getErpUser', this.mds.dataE(obj)).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    return resp;
  }

  async loginERP(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/login', this.mds.dataE(obj)).toPromise().then(res => {
      return this.mds.dataD(res);
    }).catch((err: any) => {
      // HTTP error responses (4xx/5xx): the API body is in err.error
      if (err?.error && err.error.hasOwnProperty('error')) {
        return err.error;
      }
      return { error: true, data: 'Unable to connect. Please try again.' };
    });
    // console.log(resp)
    return resp;
  }

  refreshAccessToken(refreshToken: string) {
    return this.http.post<any>(this.httpUrl + '/auth/refresh', { refreshToken });
  }

  async createloginInfo(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/loginInfo/createloginInfo', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getDataFromMobileNumberOrEmail(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/getDataFromMobileNumberOrEmail' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async forgetPass(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/forgetpassword', this.mds.dataE(obj)).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async sendCpatTokenToBackend(token: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/acms/integration/cpatToken', token).toPromise().then(res => {
      return res;
    });
    return resp;
  }

}
